const CheckmarkSVG = () => (
    <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2 10.544 6.32 14l8.623-12"
            stroke="#20D948"
            strokeWidth="2.66"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CheckmarkSVG;
